export const renderReactLegacy = (
    Component: any,
    context: any,
    currentProps: any = {},
) => Component(currentProps, context)();
